module.exports = __webpack_public_path__ + "static/media/stef_jeff.7b60db99.jpg";